import { Outlet } from 'react-router-dom'
import MarketingNav from '../marketing/MarketingNav'
import MobileStickyCTA from '../marketing/MobileStickyCTA'
import Footer from '../marketing/Footer'

export default function MarketingLayout() {
  return (
    <div className="min-h-svh bg-white">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-ink-900 focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>
      <MarketingNav />
      <main id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  )
}
